"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = queueIncomingActivity;
exports.QUEUE_INCOMING_ACTIVITY = void 0;
var QUEUE_INCOMING_ACTIVITY = 'DIRECT_LINE/QUEUE_INCOMING_ACTIVITY';
exports.QUEUE_INCOMING_ACTIVITY = QUEUE_INCOMING_ACTIVITY;

function queueIncomingActivity(activity) {
  return {
    type: QUEUE_INCOMING_ACTIVITY,
    payload: {
      activity: activity
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3F1ZXVlSW5jb21pbmdBY3Rpdml0eS5qcyJdLCJuYW1lcyI6WyJRVUVVRV9JTkNPTUlOR19BQ1RJVklUWSIsInF1ZXVlSW5jb21pbmdBY3Rpdml0eSIsImFjdGl2aXR5IiwidHlwZSIsInBheWxvYWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSx1QkFBdUIsR0FBRyxxQ0FBaEM7OztBQUVlLFNBQVNDLHFCQUFULENBQStCQyxRQUEvQixFQUF5QztBQUN0RCxTQUFPO0FBQ0xDLElBQUFBLElBQUksRUFBRUgsdUJBREQ7QUFFTEksSUFBQUEsT0FBTyxFQUFFO0FBQUVGLE1BQUFBLFFBQVEsRUFBUkE7QUFBRjtBQUZKLEdBQVA7QUFJRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFFVRVVFX0lOQ09NSU5HX0FDVElWSVRZID0gJ0RJUkVDVF9MSU5FL1FVRVVFX0lOQ09NSU5HX0FDVElWSVRZJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gcXVldWVJbmNvbWluZ0FjdGl2aXR5KGFjdGl2aXR5KSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogUVVFVUVfSU5DT01JTkdfQUNUSVZJVFksXG4gICAgcGF5bG9hZDogeyBhY3Rpdml0eSB9XG4gIH07XG59XG5cbmV4cG9ydCB7IFFVRVVFX0lOQ09NSU5HX0FDVElWSVRZIH07XG4iXX0=